module.exports = __webpack_public_path__ + "img/insta-2.9e5fe5ad.jpg";